// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3pNcd","signatureBlock":"Footer_signatureBlock__2ryf9","signature":"Footer_signature__3EiF5"};